export default __webpack_public_path__ + "static/media/role.284e6c58.svg";